import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { BrowserRouter } from 'react-router-dom';
import { Route } from 'react-router-dom';

import { Banner, Products, Archives } from 'components';
import { loadBannerFeed } from 'redux/modules/banner-feed';
import { loadSoftwareFeed } from 'redux/modules/software-feed';
import { getString } from 'utils/translate';
import { SUPPORT_URL } from './constants.js';

class App extends Component {
  componentDidMount() {
    this.props.loadSoftwareFeed();
    this.props.loadBannerFeed();
  }

  render() {
    const { banner, displayBanner, displayErrorBanner, loading } = this.props;

    return (
      <BrowserRouter>
        <section
          id="products-list"
          style={{ background: '#fff', float: 'left', width: '100%', paddingBottom: 10 }}
        >
          <div
            style={{
              width: '100%',
              float: 'left',
              marginTop: 10,
              display: banner.length && displayBanner && !displayErrorBanner ? 'block' : 'none',
            }}
          >
            <Banner content={banner} />
          </div>
          <div
            style={{
              width: '100%',
              float: 'left',
              marginTop: 10,
              display: displayErrorBanner ? 'block' : 'none',
            }}
          >
            <Banner
              style="error"
              content={[
                `${getString(
                  'error.noConnection'
                )} <a href="${SUPPORT_URL}" target="_blank">${getString('error.contact')}</a>`,
              ]}
            />
          </div>
          <div
            style={{
              float: 'left',
              width: '100%',
              margin: '40px auto',
              textAlign: 'center',
              display: loading ? 'block' : 'none',
            }}
          >
            <div
              style={{
                width: 24,
                height: 24,
                position: "absolute",
                left: "32.5%",
                borderRadius: '50%',
                border: '4px solid #CCCCCC',
                borderTopColor: '#4971AB',
                animation: 'spin 1s infinite linear',
                display: 'inline-block',
              }}
            />
          </div>
          <Route path="/software.html" component={Products} />
          <Route path="/software-feature-releases.html" component={Products} />
          <Route path="/software-long-term-support.html" component={Products} />
          <Route path="/software-earlier-versions.html" component={Archives} />
          <Route path="/ja-jp/software.html" component={Products} />
          <Route path="/ja-jp/software-long-term-support.html" component={Products} />
          <Route path="/ja-jp/software-earlier-versions.html" component={Archives} />          
        </section>
      </BrowserRouter>
    );
  }
}

App.propTypes = {
  banner: PropTypes.array.isRequired,
  displayBanner: PropTypes.bool.isRequired,
  displayErrorBanner: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  loadBannerFeed: PropTypes.func.isRequired,
  loadSoftwareFeed: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  banner: state.bannerFeed.banner,
  displayBanner: state.bannerFeed.displayBanner,
  displayErrorBanner: state.softwareFeed.displayErrorBanner,
  loading: state.softwareFeed.loading,
});

const mapDispatchToProps = dispatch => ({
  loadBannerFeed: () => dispatch(loadBannerFeed()),
  loadSoftwareFeed: () => dispatch(loadSoftwareFeed()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
